<h1 mat-dialog-title>Asset Details</h1>
<mat-dialog-content fxLayout="column" fxLayoutGap="10px">
    <mat-tab-group mat-align-tabs="start" class="detail-component">
        <mat-tab label="Data"><app-asset-edit class="asset-detail-tab" [asset]="data" (assetChanged)="updateAsset($event)"></app-asset-edit></mat-tab>
        <mat-tab label="History"><app-table-detail-history class="asset-detail-tab" entityName="assets" [entityId]="data._id"></app-table-detail-history></mat-tab>
        <mat-tab label="General"><app-table-detail-abstract class="asset-detail-tab" [data]="data"></app-table-detail-abstract></mat-tab>
        <mat-tab label="Label"><app-label-preview class="asset-detail-tab" [label]="label" id="asset-preview" layout="row-reverse"></app-label-preview></mat-tab>
    </mat-tab-group>  
</mat-dialog-content>
<div mat-dialog-actions align="end">
    <button mat-button [disabled]="inProgress" (click)="abort()">Abort</button>
    <button mat-button [disabled]="inProgress" (click)="save()" cdkFocusInitial>Ok</button>
</div>